import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * Pulsante "torna in cima" minimal, fisso in basso a sinistra. Compare solo dopo
 * aver scrollato oltre una soglia e riporta la pagina in cima con uno scroll fluido.
 */
export function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="Torna su"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className={cn(
            'fixed bottom-4 right-4 z-40 flex h-10 w-10 items-center justify-center rounded-full',
            'border border-(--color-border) bg-(--color-background)/90 text-(--color-foreground) shadow-sm backdrop-blur',
            'transition-opacity duration-200 hover:bg-(--color-muted)',
            visible ? 'opacity-100' : 'pointer-events-none opacity-0',
          )}
        >
          <ArrowUp className="h-4 w-4" />
        </button>
      </TooltipTrigger>
      <TooltipContent side="left">Torna su</TooltipContent>
    </Tooltip>
  );
}
